import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseDetailSchema } from './shapes';

export const confirmRelease = defineEndpoint({
  method: 'POST',
  path: '/v1/releases/:releaseId/confirm',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: ReleaseDetailSchema }),
});
